import { cn } from '@xhubio-saas/core-frontend/ui-components'

interface InvoiceApiLogoProps {
  className?: string
  size?: number
  showText?: boolean
}

export function InvoiceApiLogo({ className, size = 60, showText = true }: InvoiceApiLogoProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img src={'/icon_transparent.png'} alt="logo" style={{ width: `${size}px` }} />

      {showText && (
        <span className="text-xl">
          <span className="font-bold">Invoice-API</span>
          <span className="font-normal text-muted-foreground">.xhub</span>
          <span className="font-normal text-muted-foreground"> Console</span>
        </span>
      )}
    </div>
  )
}
